var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane fade",class:{ 'show active': _vm.isActive },attrs:{"id":'tab-' + _vm.name.toLowerCase().replace(/[\W_\s]/g, ''),"role":"tabpanel"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }